<template>
    <section class="content">
        <div class="container-fluid">

            <div class="row">
                        
                <div class="col-sm-12">  
                    <div class="card">
                        <div class="card-header">
                            <div class="row">                                                   
                                <div class="col">
                                    <h5>Active Subscriptions</h5>
                                </div>
                            </div>
                        </div>
                        <div class="card-body p-0">
                            <div class="table-responsive">
                                <table class="table table-striped table-bordered" id="anet_table">
                                    <thead>
                                        <tr>
                                            <th>Created</th>
                                            <th>Subscription Name</th>
                                            <th>Customer Name</th>
                                            <th>Payment Amount</th>
                                            <th>Payment Count</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in AnetData" >
                                            <td>{{item.created}}</td>
                                            <td>{{item.name}}</td>
                                            <td>{{item.customer}}</td>
                                            <td>{{item.amount}} {{item.currency}}</td>
                                            <td>{{item.payment_count}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
</template>

<script>

    export default {
        data () {

            return {
                TableHeaders: {},
                AnetData: {},
            }

        },
        mounted() {


        },
        updated: function () {

          this.$nextTick(function () {
                $('#anet_table').DataTable({order: [[0, 'asc']]});
          })

        },
        methods: {
            getStatsData() {
                axios.get("/api/v1/anetapi/recurring_billing").then(({ data }) => {
                    this.AnetData = data.data.AnetData
                    console.log(this.AnetData);
                });
            }

        },
        created() {

            this.getStatsData();
        }
    }
</script>
